export const APP_RESUME_REFRESH_EVENT = 'qcl:app-resume-refresh';

export const emitAppResumeRefresh = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(APP_RESUME_REFRESH_EVENT));
};
